import React, { useEffect, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, Route, Routes, Navigate } from 'react-router-dom'
import { getOneRosterUser } from '../../../store/OneRoster/OneRosterUserAction';
import StatusCode from '../../../util/StatusCode';
import RenderTabs from '../../misc/Tabs';
import * as Tab from '../../../util/TabValue';
import { CoreOneRosterUser } from '../../../models/CoreOneRosterModels';
import { RequestState } from '../../../models/RequestState';
import { useTranslation } from "react-i18next";
import NotFound from '../../administration/components/NotFound';
import OneRosterUserInfo from './OneRosterUserInfo';
import Loading from '../../misc/Loading';
import OneRosterUserSchoolUnits from './OneRosterUserSchoolUnits';
import OneRosterUserClasses from './OneRosterUserClasses';
import { RootState } from '../../../store/store';
import OneRosterUserTools from './OneRosterUserTools';


const OneRosterUser = () => {
    const { t } = useTranslation(['common', 'oneRoster']);

    const { userId } = useParams();
    const dispatch = useDispatch();
    const user = useSelector<RootState, RequestState<CoreOneRosterUser>>(state => state.onerosterUser.user);

    useEffect(() => {
        if (userId) {
            getOneRosterUser(userId)(dispatch);
        }
    }, [dispatch, userId]);

    const tabs = [
        Tab.Tabs.Information,
        Tab.Tabs.UserSchoolUnits,
        Tab.Tabs.Classes,
        Tab.Tabs.Tools,
    ];

    if (userId === undefined) {
        return;
    }

    const renderContent = (body: any) => (
        <div className="padding-40 container single">
            <h1><Link to="/oneroster/user">{t('object.oneRoster.user', { ns: 'common', count: 1 })}</Link> {displayName}</h1>
            {body}
        </div>
    )

    let displayName: string | undefined = '';

    switch (user.code) {
        case StatusCode.COMPLETE:
            displayName = `${user.data.givenName} ${user.data.familyName}`;
            return (renderContent(<>
                <RenderTabs
                    tabs={tabs}
                    id={userId}
                    url="oneroster/user" />

                <Suspense>
                    <Routes>
                        <Route path={Tab.Tabs.Information.url} element={<OneRosterUserInfo />} />
                        <Route path={Tab.Tabs.UserSchoolUnits.url} element={<OneRosterUserSchoolUnits />} />
                        <Route path={Tab.Tabs.Classes.url} element={<OneRosterUserClasses />} />
                        <Route path={Tab.Tabs.Tools.url} element={<OneRosterUserTools />} />
                        <Route path="*" element={<Navigate replace={true} to={`/oneroster/user/${userId}/${Tab.Tabs.Information.url}`} />} />
                    </Routes>
                </Suspense>
            </>));
        case StatusCode.ERROR:
            if (user.error.response?.status === 404 || user.error.response?.status === 400) {
                return <NotFound
                    header={t('object.oneRoster.user', { ns: 'common', count: 1 })}
                    translateKey={{ i18nKey: "notFound.user", ns: "oneRoster" }}
                    link="/oneroster/user"
                />
            } else {
                return renderContent(<p>{user.error.response?.statusText}</p>);
            }
        default:
            return (renderContent(<Loading />));
    }
}

export default OneRosterUser;
